import { z } from "zod";
export const TicketSummary = z.object({
    id: z.string(),
    source: z.string(),
    type: z.string().nullable(),
    parentId: z.string().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    status: z.string().nullable(),
    resolution: z.string().nullable(),
    labels: z.array(z.string()),
    components: z.array(z.string()),
    createdAt: z.string().datetime().nullable(),
    updatedAt: z.string().datetime().nullable(),
});
export const TicketsListResponse = z.object({
    tickets: z.array(TicketSummary),
});
export const TicketsListQuery = z.object({
    type: z.string().optional(),
    status: z.string().optional(),
    limit: z.coerce.number().int().positive().max(500).optional(),
});
export const TicketIdParam = z.object({
    id: z.string().min(1),
});
//# sourceMappingURL=tickets.js.map